import React, { useState, useEffect } from 'react';
import FlipBook from '../components/FlipBook';

const Library = ({ lang }) => {
  const [chapters, setChapters] = useState([]);
  const [openPdf, setOpenPdf] = useState(null);

  useEffect(() => {
    fetch('/api/v1/chapters/' + lang)
      .then(r => r.json())
      .then(d => {
        let chaps = d.chapters || [];
        chaps.sort((a, b) => {
          const numA = parseInt(a.filename.match(/^(\d+)/)?.[1] || '0');
          const numB = parseInt(b.filename.match(/^(\d+)/)?.[1] || '0');
          return numA - numB;
        });
        setChapters(chaps);
      })
      .catch(e => console.error(e));
  }, [lang]);

  const getIcon = (title) => {
    const t = title.toLowerCase();
    if (t.includes('foi') || t.includes('faith')) return '☪️';
    if (t.includes('coran') || t.includes('quran') || t.includes('guour')) return '📖';
    if (t.includes('sounnah') || t.includes('sunnah')) return '📜';
    if (t.includes('prophete') || t.includes('prophet') || t.includes('mouhammad') || t.includes('biography')) return '✨';
    if (t.includes('califes') || t.includes('caliphs') || t.includes('guided')) return '👑';
    if (t.includes('priere') || t.includes('prayer') || t.includes('friday')) return '🤲';
    if (t.includes('groupe') || t.includes('group')) return '👥';
    if (t.includes('occasionnelles') || t.includes('supererogatory') || t.includes('occasional')) return '🌟';
    if (t.includes('manquees') || t.includes('missed')) return '⏰';
    if (t.includes('invocation') || t.includes('rappel') || t.includes('reminder')) return '📿';
    if (t.includes('mosquee') || t.includes('mosque')) return '🕌';
    if (t.includes('zakat')) return '💰';
    if (t.includes('jeune') || t.includes('jeûne') || t.includes('fasting') || t.includes('ramadhan')) return '🌙';
    if (t.includes('retraite') || t.includes('retreat') || t.includes('spiritual stay')) return '🧎';
    if (t.includes('calendrier') || t.includes('lunaire') || t.includes('hegira') || t.includes('lunar')) return '📅';
    if (t.includes('pelerinage') || t.includes('pilgrimage') || t.includes('hajj')) return '🕋';
    if (t.includes('licite') || t.includes('illicite') || t.includes('lawful') || t.includes('illicit')) return '⚖️';
    if (t.includes('halal') || t.includes('rite')) return '🍖';
    if (t.includes('chasse') || t.includes('peche') || t.includes('hunting') || t.includes('fishing')) return '🎣';
    if (t.includes('repentir') || t.includes('repentance')) return '🙏';
    if (t.includes('famille') || t.includes('family')) return '👨‍👩‍👧‍👦';
    if (t.includes('enfant') || t.includes('children') || t.includes('education')) return '👶';
    if (t.includes('harcelement') || t.includes('harassment')) return '🛡️';
    if (t.includes('procreation')) return '🏥';
    if (t.includes('grossesse') || t.includes('pregnancy') || t.includes('ivg')) return '⚕️';
    if (t.includes('transgenre') || t.includes('transgender') || t.includes('homosexuel') || t.includes('same-sex')) return '⚧️';
    if (t.includes('funerailles') || t.includes('funeral')) return '🕯️';
    if (t.includes('heritage') || t.includes('inheritance')) return '📋';
    if (t.includes('morale') || t.includes('morality') || t.includes('comportement') || t.includes('behavior')) return '💎';
    if (t.includes('gouvernance') || t.includes('governance')) return '🏛️';
    if (t.includes('equite') || t.includes('fairness') || t.includes('justice')) return '⚖️';
    if (t.includes('transaction') || t.includes('financial')) return '💼';
    if (t.includes('assurance') || t.includes('insurance')) return '📑';
    if (t.includes('insouciance') || t.includes('carefulness')) return '⚠️';
    if (t.includes('adoration') || t.includes('worship')) return '🛐';
    return '📄';
  };

  const displayTitle = (filename) => {
    return filename
      .replace(/\.pdf$/i, '')
      .replace(/_/g, ' ');
  };

  const openReader = (ch) => {
    setOpenPdf({
      url: `/api/v1/chapter/${lang}/${ch.id}/view`,
      title: displayTitle(ch.filename)
    });
  };

  const closeReader = () => {
    setOpenPdf(null);
  };

  const labels = {
    fr: { 
      title: 'Feuilleter', 
      chapters: 'chapitres',
      supportTitle: 'Soutenir le projet',
      supportText: 'Si vous souhaitez aider financièrement à la maintenance du site et à la production de nouveaux documents, vous pouvez nous soutenir.',
      supportBtn: 'Soutenir le projet'
    },
    en: { 
      title: 'Browse', 
      chapters: 'chapters',
      supportTitle: 'Support the project',
      supportText: 'If you wish to financially support the maintenance of the site and the production of new documents, you can support us.',
      supportBtn: 'Support the project'
    }
  };

  const L = labels[lang];

  if (openPdf) {
    return (
      <FlipBook
        pdfUrl={openPdf.url}
        title={openPdf.title}
        onClose={closeReader}
        lang={lang}
      />
    );
  }

  return (
    <div className="library">
      <h1>📚 {L.title}</h1>
      
      <section className="chapters-section">
        <h2>{lang === 'en' ? '📖 Chapters' : '📖 Chapitres'}</h2>
        <p className="chapter-count">{chapters.length} {L.chapters}</p>
        <div className="chapters-grid">
          {chapters.map((ch) => (
            <div key={ch.id} className="chapter-card" onClick={() => openReader(ch)}>
              <span className="chapter-icon">{getIcon(ch.filename)}</span>
              <h3>{displayTitle(ch.filename)}</h3>
            </div>
          ))}
        </div>
      </section>

      <section className="support-section">
        <h2>💝 {L.supportTitle}</h2>
        <p>{L.supportText}</p>
        <a href="/support" className="btn-donate">{L.supportBtn}</a>
      </section>
    </div>
  );
};

export default Library;
